import './SuperAdminPartnerMgmnt.scss'
import {buttonColors} from "../../Pickers/InputTheme";
import {i18n} from "../../../Utils/i18n/i18n";
import {Button} from "../../Form/Button/Button";
import React from "react";
import {GridReactContextProvider} from "../../../Utils/DataGridWrapper/GridContext";
import {SuperAdminPartnersTable} from "../SuperAdminPartnersTable/SuperAdminPartnersTable";
import {SuperAdminCreateNewPartnerModal} from "../SuperAdminCreateNewPartner/SuperAdminCreateNewPartnerModal";
import '../SuperAdminPage.scss'

export const SuperAdminPartnerMgmnt = () => {
    const [isCreateNewPartnerModalOpen, setIsCreateNewPartnerModalOpen] = React.useState(false)
    const openCreateNewPartnerModal = () => {
        setIsCreateNewPartnerModalOpen(true)
    }
    const closeCreateNewPartnerModal = () => {
        setIsCreateNewPartnerModalOpen(false)
    }
    return <div className="SuperAdminPartnerMgmnt SuperAdminPage">
        <div className="buttonsWrapper">
            <Button color={buttonColors.GREY}
                // style={{width: '100%'}}
                    text={i18n.translate('superAdmin.createNewPartner.modalTitle')}
                    onClick={openCreateNewPartnerModal}/>
        </div>
        <GridReactContextProvider>
            <div className="superAdminPartnersTableWrapper">
                <SuperAdminPartnersTable/>
            </div>
            {isCreateNewPartnerModalOpen && <SuperAdminCreateNewPartnerModal
                createPartnerModalOpen={isCreateNewPartnerModalOpen}
                onCompleted={closeCreateNewPartnerModal}
                closeCreatePartnerModal={closeCreateNewPartnerModal}/>}
        </GridReactContextProvider>
    </div>
}